<div *ngIf="!acceptFolder; else uploadFolder" class="import-file input-file-container">
    <h3>{{ 'SelectFiles' | translate }}</h3>

    <div class="file-selector"
         [ngClass]="{'drag-start': isDragEnter}"
         (dragenter)="isDragEnter = true"
         (dragleave)="isDragEnter = false"
         (dragover)="onDragOver($event)"
         (drop)="onDrop($event)">
        <div class="input-label-container">
            <label for="file"><strong>{{ 'ChooseFile' | translate }}</strong></label>

            <input type="file" id="file" [accept]="acceptedTypeFile"
                   (change)="onFileSelected($event)" (click)="$event.target.value=null" multiple>

            <div class="box__dragndrop"> {{ 'DragHere' | translate }}</div>
        </div>
    </div>
</div>
    
<ng-template #uploadFolder>
<div class="import-file input-file-container">
    <h3>{{ 'SelectFolders' | translate }}</h3>

    <div class="file-selector"
         [ngClass]="{'drag-start': isDragEnter}"
         (dragenter)="isDragEnter = true"
         (dragleave)="isDragEnter = false"
         (dragover)="onDragOver($event)"
         (drop)="onDrop($event)">
        <div class="input-label-container">
            <label for="folder"><strong>{{ 'ChooseFolder' | translate }}</strong></label>

            <input type="file" id="folder"
                   (change)="onFileSelected($event)" (click)="$event.target.value=null" webkitdirectory multiple>

            <div class="box__dragndrop"> {{ 'DragHereFolder' | translate }}</div>
        </div>
    </div>
</div>
</ng-template>
